

const ProfileOverview = () => {
  return (
    <div className="flex w-full flex-col gap-5 ">
      <div className="relative mt-[3px] flex h-[61px] w-[auto] flex-grow items-center justify-around gap-1 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none  md:flex-grow-0 md:gap-1  xl:gap-2">
      

      </div>
      

     
    </div>
  );
};

export default ProfileOverview;
